import { api } from "@/lib/api";
import type {
  ActivityItem,
  CoachActivityItem,
  CoachContentItem,
  CoachQualityData,
  ContentPerformanceData,
  DashboardStats,
  ManagerStatsData,
  PendingReviewItem,
  RevenueChannelsData,
  RevenueData,
  SubscriptionHealthData,
} from "@/lib/schema";

export interface ContentOverviewData {
  totalContent: number;
  statusCounts: Record<string, number>;
  typeCounts: Record<string, number>;
  approvalPressure: {
    pendingReview: number;
    approvalsToday: number;
    rejectionsToday: number;
  };
  coachStats: { total: number; active: number; contentThisWeek: number };
  systemAlerts: {
    missingTags: number;
    missingLanguages: number;
    missingCategories: number;
    failedPublishes: number;
    total: number;
  };
}

export type DashboardPeriod = "7days" | "30days" | "alltime";

export const dashboardService = {
  stats: () => api.get<DashboardStats>("/dashboard/stats"),
  activities: () => api.get<ActivityItem[]>("/dashboard/activities"),
  myContent: () => api.get<CoachContentItem[]>("/dashboard/my-content"),
  subscriptionHealth: () =>
    api.get<SubscriptionHealthData>("/dashboard/subscription-health"),
  revenue: (period: DashboardPeriod) =>
    api.get<RevenueData>(`/dashboard/revenue?period=${period}`),
  revenueChannels: (period: DashboardPeriod) =>
    api.get<RevenueChannelsData>(
      `/dashboard/revenue-channels?period=${period}`,
    ),
  contentOverview: () =>
    api.get<ContentOverviewData>("/dashboard/content-overview"),
  pendingReviews: () =>
    api.get<PendingReviewItem[]>("/dashboard/pending-reviews"),
  coachActivity: () =>
    api.get<CoachActivityItem[]>("/dashboard/coach-activity"),
  contentPerformance: () =>
    api.get<ContentPerformanceData>("/dashboard/content-performance"),
  coachQuality: () => api.get<CoachQualityData>("/dashboard/coach-quality"),
  managerStats: () => api.get<ManagerStatsData>("/dashboard/manager-stats"),
};
